<template>
<section id="company-select">
    <NavbarDefault />
    <el-progress :stroke-width="2" :color="getPrimaryColorHex.four" :show-text="false" :percentage="20" />
    <div class="container px-5">
        <Button @click="$router.go(-1)" size="small" type="outline" color="grey" class="ml-5">
            <ArrowDropdown :rotate="90" /> Voltar
        </Button>
        <div class="col my-5 pb-5">
            <div class="mx-auto text-center mt-4" style="max-width: 584px; max-height: 449px;">
                <h2 :class="`c-${getPrimaryColor}four`">Crie seu login de acesso!</h2>
                <p class="c-ndarkfour regular">Cadastre-se para acessar o perfil da sua empresa na plataforma</p>
                
                <el-form :model="user" ref="user" :rules="rules" class="text-left mt-5" name="signUpForm">
                    <div class="row">
                        <div class="col-7">
                            <el-form-item prop="name" class="mt-4 mb-3">
                                <label>
                                    Nome completo
                                </label>
                                <el-input
                                    class="input-signup"
                                    name="fullName"
                                    :class="getPrimaryColor"
                                    v-model="user.name"
                                    placeholder="Seu nome"
                                    @keyup.native="validateField('name')"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-5">
                            <el-form-item prop="phoneNumber" class="mt-4 mb-3">
                                <label>
                                    Telefone celular
                                </label>
                                <the-mask
                                    class="input-money signup"
                                    @input="validateField('phoneNumber')"
                                    name="phoneNumber"
                                    :mask="['(##) ####-####', '(##) #####-####']"
                                    v-model="user.phoneNumber"
                                    type="text"
                                    :masked="false"
                                    placeholder="(99) 99999-9999"
                                />
                            </el-form-item>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <el-form-item prop="email" class="mt-4 mb-3">
                                <label>
                                    E-mail
                                </label>
                                <el-input
                                    class="input-signup"
                                    name="email"
                                    type="email"
                                    :class="getPrimaryColor"
                                    v-model="user.email"
                                    placeholder="Seu e-mail"
                                    @keyup.native="validateField('email')"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="confirmEmail" class="mt-4 mb-3">
                                <label>
                                    Confirme seu e-mail
                                </label>
                                <el-input
                                    class="input-signup"
                                    name="confirmEmail"
                                    type="email"
                                    :class="getPrimaryColor"
                                    onpaste="return false"
                                    v-model="user.confirmEmail"
                                    placeholder="Seu e-mail"
                                    @keyup.native="validateField('confirmEmail')"
                                />
                            </el-form-item>
                        </div>
                    </div>

                    <div class="regular c-ndarkfour my-4 d-flex justify-content-center align-items-start mx-5">
                        <InputCheckboxGroup :whitelabel="getPrimaryColor"  v-model="user.checked" :items="[{value: true}]" />
                        <p>
                            Li e concordo com os<span :class="`pointer c-${getPrimaryColor}four`" @click="gotoTerms"> Termos de uso </span> e 
                            <span :class="`pointer c-${getPrimaryColor}four`" @click="gotoPolicy">política de privacidade</span>
                            da <span> {{ getWhiteLabel  |  capitalizeFirstLetter }} </span> e declaro, para todos os fins, que estou autorizado pelo Fornecedor para vincular-me às condições
                            definidas nos links acima, sob as penas da lei.
                        </p>
                    </div>
                    <button
                        type="submit"
                        :class="`btn btn-${getPrimaryColor} w-100 justify-content-center`"
                        :disabled="!buttonDisabled || !user.checked"
                        @click.prevent.stop="handleContinueButton"
                    >
                        Continuar
                    </button>
                </el-form>
                <div class="d-flex justify-content-center align-content-center" v-if="getWhiteLabel === 'CIABRA'" >
                    <PoweredByColorful class="mt-5" color="#0A735A" />
                </div>
            </div>
        </div>
    </div>
    <AlreadyRegisteredModal :dialogVisible="dialogVisibleRegister" @closeModal="dialogVisibleRegister = $event" />
    <Footer />
    <!-- <CookiesInfo /> -->
    <FullLoading :color="getPrimaryColorHex.five" v-show="$store.state.user.loading" />
</section>
</template>

<script>
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault'
import Footer from '@/components/navigation/footer/Footer'
import FullLoading from '@/components/loading/FullLoading'
import removeMask from '@/utils/removeMask'
import signUpRequest from '@/api/signUp'
import Cookies from 'js-cookie'
import AlreadyRegisteredModal from '@/components/modals/AlreadyRegistered'
import PoweredByColorful from '@/components/icons/PoweredByColorful'
import ArrowDropdown from '@/components/icons/ArrowDropdown'
// import CookiesInfo from '@/components/infos/CookiesInfo'

export default {
    components: {
    NavbarDefault,
    Footer,
    FullLoading,
    AlreadyRegisteredModal,
    PoweredByColorful,
    ArrowDropdown,
    // CookiesInfo
},
    data() {
        const validateName = (_rule, value, message) => {
            if (value.trim().split(' ').length <= 1) message('Por favor, insira o seu nome completo')
            else message()
        }
        const validateConfirmEmail =  (_rule, value, message) => {
            if (value !== this.user.email) message('Os e-mails devem ser iguais')
            else message()
        }
        const validatePhoneNumber =  (_rule, value, message) => {
            if (value.length < 11) message('Por favor, insira um telefone válido')
            else message()
        }
        return {
            user: {
                name: '',
                email: '',
                phoneNumber: '',
                checked: false,
                confirmEmail: '',
            },
            rules: {
                email: [{
                        required: true,
                        message: 'Por favor, insira o seu e-mail',
                        trigger: 'change'
                    },
                    {
                        type: 'email',
                        message: 'Por favor, insira um e-mail válido',
                        trigger: 'change'
                    }
                ],
                confirmEmail: [{
                        required: true,
                        message: 'Por favor, confirme o seu e-mail',
                        trigger: 'change'
                    },
                    {
                        type: 'email',
                        message: 'Por favor, insira um e-mail válido',
                        trigger: 'change'
                    },
                    {
                        validator: validateConfirmEmail,
                        trigger: 'change'
                    }
                ],
                name: [{
                        required: true,
                        message: 'Por favor, insira o seu nome',
                        trigger: 'change'
                    },
                    {
                        min: 3,
                        message: 'Seu nome deve ter no mínimo 3 caracteres',
                        trigger: 'change'
                    },
                    {
                        validator: validateName,
                        trigger: 'change'
                    }
                ],
                phoneNumber: [{
                        required: true,
                        message: 'Por favor, insira o seu telefone celular',
                        trigger: 'change'
                    },
                    {
                        validator: validatePhoneNumber,
                        trigger: 'change'
                    }
                ]
            },
            formValid: false,
            dialogVisible:false,
            validFields: {
                name: false,
                email: false,
                confirmEmail: false,
                phoneNumber: false
            },
            dialogVisibleRegister: false
        }
    },
    computed: {
        buttonDisabled() {
            const { name, email, confirmEmail, phoneNumber } = this.validFields
            const isSameEmails = this.user.email === this.user.confirmEmail
            return (name && email && confirmEmail && phoneNumber || this.formValid) && isSameEmails
        }
    },
    methods: {
        validateForm() {
            this.$refs['user'].validate((valid) => {
                if (valid) {
                    this.formValid = true
                } else {
                    this.formValid = false
                }
            });
        },
        validateField(field) {
            this.$refs['user'].validateField(field, (valid) => {
                if (!valid) {
                    this.validFields[field] = true
                } else {
                    this.validFields[field] = false
                }
            });
        },
        gotoPolicy(){
            this.$store.commit('register/setUser', this.user)
            this.$router.push(`/politica`)
        },
        gotoTerms(){
            this.$store.commit('register/setUser', this.user)
            this.$router.push(`/termos`)
        },
        async handleContinueButton() {
            const payload = {
                name: this.user.name,
                email: this.user.email,
                phoneNumber: removeMask(this.user.phoneNumber),
                checked: this.user.checked,
                partner: this.getWhiteLabel,
                cnpjId: this.$store.state.register.company.cnpjId,
                hasAcceptedTerms: true,
            }
            const result = await signUpRequest(payload)
            if (result.ok) {
                const pathFill = result.payload.fill;
                
                Cookies.set('token', result.payload.token, {
                    expires: 1,
                    domain: process.env.VUE_APP_ROOT_DOMAIN
                })
                this.$store.commit('user/setInfoSignUp', result.payload.token)

                if (pathFill) {
                    return this.$router.push(`/signup/${pathFill}`)
                } 
                
                return this.$router.push(`/signup/emailconfirm`)
            } else {
                if (result.message == 'email is already registered') {
                    this.dialogVisibleRegister = true
                } else {
                    this.$notify({
                        title: 'Opa! Encontramos algum erro.',
                        message: '',
                        type: 'error',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                        customClass: 'error'
                    });
                }
            }                
        },
    },
    created() {
        this.$store.commit('user/setLoading', false)

        if (this.$store.state.register.user.name) {
            this.user = { ...this.$store.state.register.user }
            this.validFields = {
                name: this.user.name ? true : false,
                email: this.user.email ? true : false,
                confirmEmail: this.user.confirmEmail ? true : false,
                phoneNumber: this.user.phoneNumber ? true : false
            }
        }
    }
}
</script>

<style scoped>
    .pointer {
        cursor:pointer;
    }
</style>
